import { FeedbackState } from 'stores/types';

export const initialState: FeedbackState = {
  showFeedback: false,
};
